import './EnhancedEventViewHeader.scss';
import { useTranslation } from 'react-i18next';
import EnhancedEventViewReleaseEvent from '../EnhancedEventViewReleaseEvent/EnhancedEventViewReleaseEvent';
import { eventActivityType, eventTrainingList } from '../../../constants/myBlockMonth';
import { formatNumToTime, getDeviationValue } from '../../../helpers/timeHelpers';
import { getEventName, getEventSubTitle } from '../../../pages/MyBlockMonth/myBlockMonthHelper';

function EnhancedEventViewHeader({actualView, event, eventType}) {
  const { t } = useTranslation();

  const getClassForEventTypeHeader = (activityType) => {
    switch (activityType) {
      case eventActivityType.PAIRING: case eventActivityType.RESERVE: case eventActivityType.RAP: case eventActivityType.RAPH:
        return "c-enhanced-event-view-header"
      case eventActivityType.SICK: case eventActivityType.SICK_INS:
        return "c-enhanced-event-view-header c-enhanced-event-view-header--sick";
      case eventActivityType.VACATION: case eventActivityType.SDO: case eventActivityType.VAC2448:
        return "c-enhanced-event-view-header c-enhanced-event-view-header--vac";
      case eventActivityType.DSP:
        return "c-enhanced-event-view-header c-enhanced-event-view-header--dsp";
      case eventActivityType.PIT: case eventActivityType.REASSIGN:
        return "c-enhanced-event-view-header c-enhanced-event-view-header--reassign"
      case eventActivityType.TRAINING: case eventActivityType.ITC:
        return "c-enhanced-event-view-header c-enhanced-event-view-header--training";
      case eventActivityType.GDO6: case eventActivityType.GDO: case eventActivityType.TDO6: case eventActivityType.TDO:
        return "c-enhanced-event-view-header c-enhanced-event-view-header--gdo";
      default:
        return "c-enhanced-event-view-header";
    }
  };

  const getClassNameForCheckOut = (parameter) => {
    if(!actualView){
      return "c-enhanced-event-view-header__value";
    }
    if(parameter?.deviation > 0){
      return "c-enhanced-event-view-header__value eev__header__deviation__negative";
    }
    else if(parameter?.deviation < 0){
      return "c-enhanced-event-view-header__value eev__header__deviation__positive";
    }
    else{
      return "c-enhanced-event-view-header__value";
    }
  }

  const getTimeWithDeviation = (parameter) => {
    if(!actualView){
      return formatNumToTime(parameter?.value);
    }
    const deviationValue = parameter?.deviation ? ' ('+getDeviationValue(parameter?.deviation)+')' : '';
    return formatNumToTime(parameter?.value) + ' '+ deviationValue ;
  }

  return (
    <>
      <div className={getClassForEventTypeHeader(eventType)}>
        <div>
          <p className={eventType === eventActivityType.PAIRING? 'event-name event-name--pairing' : 'event-name'}>
            {eventType === eventActivityType.PAIRING ? event.activityId : getEventName(event)}
          </p>
          {eventType !== eventActivityType.PAIRING ? <p className="event-subtitle">{getEventSubTitle(event)}</p> : null}
        </div>

        <div className={eventType === eventActivityType.PAIRING? 'c-header-details c-header-details--pairing' : 'c-header-details'} style={{width: actualView ? '49%' : '75%'}}>
          {eventType === eventActivityType.DSP
          || eventType === eventActivityType.ITC
          || eventType === eventActivityType.PAIRING 
          || eventType === eventActivityType.SDO
          || eventType === eventActivityType.SICK 
          || eventType === eventActivityType.SICK_INS
          || eventType === eventActivityType.TRAINING
          || eventType === eventActivityType.VACATION  
          || eventType === eventActivityType.VAC2448 ? (
            <div 
              className={
                event.activityId === eventTrainingList.SCHOOL || event.activityId === eventTrainingList.IOE || event.activityId === eventTrainingList.ART 
                  ? 'c-detail c-detail--training'
                  : event.activityType === eventActivityType.DSP ? 'c-detail c-detail--dsp' : 'c-detail'
              }
            >
              {eventType !== eventActivityType.SICK_INS && (
                <>
                  <p className="detail__title">
                    {
                      eventType === eventActivityType.DSP || eventType === eventActivityType.ITC || eventType === eventActivityType.SDO || eventType === eventActivityType.TRAINING
                      ? t('myBlockMonth.displacedDays') 
                      :eventType === eventActivityType.PAIRING 
                      ? t('myBlockMonth.checkIn') 
                      : eventType === eventActivityType.SICK
                      ? t('myBlockMonth.sickDay')
                      : eventType === eventActivityType.VACATION
                      ? t('myBlockMonth.vacationDay') 
                      : t('myBlockMonth.days')
                    }
                  </p>
                  <p className={getClassNameForCheckOut(event?.checkIn)}>
                    {eventType === eventActivityType.PAIRING ? getTimeWithDeviation(event?.checkIn) : event?.days }
                    {eventType === eventActivityType.PAIRING && event.pairingDetails.onduty.dayBefore && <em> -1 day</em>}
                  </p> 
                </>
              )}
            </div>
          ) : null}

          {eventType === eventActivityType.GDO 
            || eventType === eventActivityType.GDO6 
            || eventType === eventActivityType.RESERVE 
            || eventType === eventActivityType.RAP 
            || eventType === eventActivityType.RAPH
            || eventType === eventActivityType.TDO 
            || eventType === eventActivityType.TDO6 ? (
              <div className="c-detail">
                <p className={eventType === eventActivityType.RAP || eventType === eventActivityType.RAPH ? 'detail__title--rap' : 'detail__title'}>{t('myBlockMonth.duration')}</p>
                <p className="detail__duration">{eventType === eventActivityType.RAP || eventType === eventActivityType.RAPH ? event?.duration.split('(')[0] : event?.duration}</p>
              </div> 
            ) : null}

          {eventType === eventActivityType.DSP || eventType === eventActivityType.PAIRING ? (
            <span className={eventType === eventActivityType.PAIRING ? 'event-header__divider' : 'event-header__divider--special'} /> 
          ) : null}

          {eventType === eventActivityType.DSP || eventType === eventActivityType.PAIRING || eventType === eventActivityType.REASSIGN ?
            <div className={eventType === eventActivityType.DSP || eventType === eventActivityType.REASSIGN ? 'c-detail--reassign' : 'c-detail'}>
              <p className={eventType === eventActivityType.DSP || eventType === eventActivityType.REASSIGN ? 'detail__title--dsp-reassign' : 'detail__title'}>
                {eventType === eventActivityType.PAIRING ? t('myBlockMonth.checkOut') 
                  : eventType === eventActivityType.DSP || eventType === eventActivityType.REASSIGN ? t('myBlockMonth.protectedCredit') 
                  : t('myBlockMonth.credit')
                }
              </p>
              <p className={getClassNameForCheckOut(event?.checkOut)}>
                {eventType === eventActivityType.PAIRING 
                  ? getTimeWithDeviation(event?.checkOut) 
                  : event?.credit?.value ? formatNumToTime(event?.credit?.value) 
                  : eventType === eventActivityType.DSP || eventType === eventActivityType.PIT || eventType === eventActivityType.REASSIGN ? event?.originalPairingCredit : 'N/A'
                }
                {eventType === eventActivityType.PAIRING && event.pairingDetails.offduty.dayAfter && <em> +1 day</em>}
              </p>
            </div> : null}

          {eventType === eventActivityType.PAIRING ? (
            <>
              <span className="event-header__divider" />
              <div className="c-detail">
                <p className="detail__title">
                  {t('myBlockMonth.days')}
                </p>
                <p className="c-enhanced-event-view-header__value">
                  {event?.days}
                </p>
              </div>
              <span className="event-header__divider" />
              <div className="c-detail">
                <p className="detail__title">
                  {t('myBlockMonth.tafb')}
                </p>
                <p className="c-enhanced-event-view-header__value">
                  {formatNumToTime(event?.pairingDetails?.tafb?.value ?? 0)}
                </p>
              </div>
              {!actualView && (
                <>
                  <span className="event-header__divider" />
                  <div className="c-detail">
                    <p className="detail__title">
                      {t('myBlockMonth.initialCredit')}
                    </p>
                    <p className="c-enhanced-event-view-header__value">
                      {getTimeWithDeviation(event?.pairingDetails?.credit)}
                    </p>
                  </div>
                  <span className="event-header__divider" />
                  <div className="c-detail">
                    <p className="detail__title">
                      {t('myBlockMonth.initialExpenses')}
                    </p>
                    <p className="c-enhanced-event-view-header__value">
                      ${(event?.pairingDetails?.totalAllowance?.value).toFixed(2)}
                    </p>
                  </div>
                </> 
              )}          
            </>
          ) : null}
        </div>
      </div>
      {event?.release && event.activityType === eventActivityType.PAIRING 
        ? <EnhancedEventViewReleaseEvent activityType={eventType} event={event?.release[0]} /> 
        : null
      }
    </>
  );
}

export default EnhancedEventViewHeader;
